import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, User, Menu, X } from 'lucide-react';

const Header10 = ({ cartCount = 0 }) => {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [mobileMenuOpen]);

    const navLinks = [
        { label: 'Home', path: '/template10' },
        { label: 'Shop', path: '/template10/shop' },
        { label: 'About', path: '/template10/about' },
        { label: 'Contact', path: '/template10/contact' },
        { label: 'Orders', path: '/template10/orders' },
    ];

    const handleNavClick = (path) => {
        navigate(path);
        setMobileMenuOpen(false);
    };

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <header
                className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
                style={{
                    backgroundColor: scrolled ? 'rgba(255, 255, 255, 0.98)' : '#FFFFFF',
                    borderBottom: '1px solid #E7E5E4',
                }}
            >
                <div className="max-w-[1200px] mx-auto px-5 md:px-8 flex justify-between items-center h-16 md:h-[72px]">
                    {/* Logo */}
                    <h1
                        onClick={() => navigate('/template10')}
                        className="text-base md:text-lg font-light tracking-[3px] text-[#1C1917] cursor-pointer uppercase"
                        style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                        STHIR
                    </h1>

                    {/* Desktop Nav */}
                    <nav className="sthir-desktop-nav hidden md:flex items-center gap-10">
                        {navLinks.map((link) => (
                            <button
                                key={link.label}
                                onClick={() => handleNavClick(link.path)}
                                className="text-[13px] font-light tracking-[1px] text-[#78716C] hover:text-[#1C1917] transition-colors duration-300 uppercase bg-transparent border-none cursor-pointer p-0"
                                style={{ fontFamily: "'Inter', sans-serif" }}
                            >
                                {link.label}
                            </button>
                        ))}
                    </nav>

                    {/* Right Icons */}
                    <div className="flex items-center gap-5">
                        <User
                            size={18}
                            className="text-[#78716C] cursor-pointer hover:text-[#1C1917] transition-colors duration-300 hidden md:block"
                            strokeWidth={1.5}
                            onClick={() => navigate('/template10/profile')}
                        />
                        <div
                            className="relative cursor-pointer"
                            onClick={() => navigate('/template10/cart')}
                        >
                            <ShoppingCart
                                size={18}
                                className="text-[#78716C] hover:text-[#1C1917] transition-colors duration-300"
                                strokeWidth={1.5}
                            />
                            {cartCount > 0 && (
                                <span
                                    className="absolute -top-2 -right-2 w-4 h-4 bg-[#78716C] text-white text-[9px] font-normal rounded-full flex items-center justify-center"
                                    style={{ fontFamily: "'Inter', sans-serif" }}
                                >
                                    {cartCount}
                                </span>
                            )}
                        </div>

                        {/* Mobile Hamburger */}
                        <button
                            className="sthir-mobile-menu-btn md:hidden bg-transparent border-none cursor-pointer p-0"
                            onClick={() => setMobileMenuOpen(true)}
                        >
                            <Menu size={20} className="text-[#1C1917]" strokeWidth={1.5} />
                        </button>
                    </div>
                </div>
            </header>

            {/* Mobile Full-Screen Overlay */}
            <div
                className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center transition-opacity duration-300"
                style={{
                    opacity: mobileMenuOpen ? 1 : 0,
                    pointerEvents: mobileMenuOpen ? 'auto' : 'none',
                }}
            >
                <button
                    onClick={() => setMobileMenuOpen(false)}
                    className="absolute top-5 right-5 bg-transparent border-none cursor-pointer p-0"
                >
                    <X size={24} className="text-[#1C1917]" strokeWidth={1} />
                </button>

                <nav className="flex flex-col items-center gap-8">
                    {navLinks.map((link) => (
                        <button
                            key={link.label}
                            onClick={() => handleNavClick(link.path)}
                            className="text-lg font-light tracking-[3px] text-[#1C1917] uppercase bg-transparent border-none cursor-pointer p-0 hover:text-[#78716C] transition-colors duration-300"
                            style={{ fontFamily: "'Inter', sans-serif" }}
                        >
                            {link.label}
                        </button>
                    ))}
                </nav>
            </div>
        </>
    );
};

export default Header10;
